/* tslint:disable */
/* eslint-disable */
/**
 * CrateHackers API
 * This is the thing that does data stuff.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the DMSStatusResponseDto interface.
 */
export function instanceOfDMSStatusResponseDto(value) {
    if (!('loggedIn' in value) || value['loggedIn'] === undefined)
        return false;
    return true;
}
export function DMSStatusResponseDtoFromJSON(json) {
    return DMSStatusResponseDtoFromJSONTyped(json, false);
}
export function DMSStatusResponseDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'loggedIn': json['loggedIn'],
    };
}
export function DMSStatusResponseDtoToJSON(json) {
    return DMSStatusResponseDtoToJSONTyped(json, false);
}
export function DMSStatusResponseDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'loggedIn': value['loggedIn'],
    };
}
